import {useSelector} from "react-redux";
import {
  selectIncidentSettingsInitialized,
  selectIsAuthComplete,
  selectIsAuthLoading,
  selectUsersInitialized
} from "../store/selectors";

const useAppReady = () => {
  const isLoadingAuth = useSelector(selectIsAuthLoading);

  const isAuthFlowComplete = useSelector(selectIsAuthComplete);
  const isUsersComplete = useSelector(selectUsersInitialized);
  const isSettingsComplete = useSelector(selectIncidentSettingsInitialized);

  return {
    loading: isLoadingAuth,
    ready: isAuthFlowComplete && isUsersComplete && isSettingsComplete
  };
};

export default useAppReady;
